<script setup lang="ts">
import Trans from "~/modules/translations";

import { useRoute, useRouter } from "vue-router";

import { X } from "lucide-vue-next";
import { useMediaQuery } from "~/composables/useMediaQuery";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useBannerInfo } from "~/composables/useBannerInfo";

const { locale } = useI18n();
const router = useRouter();
const route = useRoute();
const isMobile = useMediaQuery("(max-width: 800px)");

const hideBannerForThesePages = computed(() => {
  return ["FlashSale", "Subscription", "Academy", "Fusion"].includes(route.name as string);
});

function goToInviteFriends() {
  router.push(Trans.i18nRoute({ name: "Competitions" }));
  bannerInfoStore.hideBanner();
}

const bannerInfoStore = useBannerInfo();
</script>

<template>
  <div
    v-if="!hideBannerForThesePages && bannerInfoStore.showBanner"
    :class="`relative bg-no-repeat hover:cursor-pointer text-xs md:text-lg h-20 flex items-center uppercase cursor-pointer border-b-[1px] border-slate-700 w-full z-40 bg-black  bg-[#060e17] `"
    @click="goToInviteFriends"
  >
    <div
      class="bg-cover bg-no-repeat absolute inset-0 -z-0"
      :style="{
        backgroundSize: 'auto 100%',
        backgroundPosition: 'center left',
        backgroundImage: 'url(https://assets.fungiball.io/banner_new_women_competitions.jpg)',
      }"
    ></div>
    <div
      class="flex flex-col mx-auto text-shadow font-semibold md:tracking-wider z-10"
      :class="isMobile ? 'text-left pl-32 pr-3' : 'text-center'"
    >
      <span class="text-shadow whitespace-normal">
        <span class="block">
          <template v-if="locale === 'fr'">🎾 Nouvelles compétitions féminines !</template>
          <template v-else>New women competitions !</template></span
        >
        <span class="text-neutral-300 text-sm md:text-base font-normal">
          <template v-if="locale === 'fr'">Dès la gameweek 49</template>
          <template v-else>Starting on Gameweek 49</template>
        </span>
      </span>
    </div>

    <div
      v-if="!isMobile"
      @click.stop="bannerInfoStore.hideBanner"
      class="absolute right-0 top-50% flex items-center z-10 border rounded-full mr-5 p-1 border-neutral-500 hover:bg-white hover:text-black hover:border-white"
    >
      <X :size="20" />
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
